app.service("EdgeOptionService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const EdgeOptionModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "edge_option",
        navigation_pointer: "edge_option_id",
        name: "Edge Option",
        next_model_id: "handle_colour"
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            matching: new RouteChoice({
                name: "Matching",
                img_src: "/img/browse/option/edge-option/edge-option-matching.png"
            }),
            plywood: new RouteChoice({
                name: "Plywood",
                img_src: "/img/browse/option/edge-option/edge-option-plywood.png"
            }),
            glass: new RouteChoice({
                name: "Glass",
                img_src: "/img/browse/option/edge-option/edge-option-glass.png"
            }),
            brushed_steel: new RouteChoice({
                name: "Brushed Steel",
                img_src: "/img/browse/option/edge-option/edge-option-brushed-steel.png"
            })
        },

        birth: function (values) {
            return new EdgeOptionModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const browseID = variationIDs.browse_id;
        const baseComponentID = variationIDs.base_component_id;
        const siteRangeID = variationIDs.site_range_id;
        const colourID = variationIDs.colour_id;

        if (browseID !== "solution" && baseComponentID !== "solution") {
            return;
        }

        const cacheColours = $rootScope.model.cache_local_server.colour.site_range[siteRangeID];
        const cacheColour = cacheColours ? cacheColours.choices[colourID] : null;

        if (!cacheColour || !cacheColour.has_edge_option) {
            return;
        }


        const choiceOrder = ['matching', 'plywood'];
        if (cacheColour.has_edge_option_glass) {
            choiceOrder.push('glass');
        }

        model.choices = siteHelper.cloneChoices(
            service.factory.choices
            , choiceOrder);

        model.choice_order = choiceOrder;
    }

}]);